import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Tabpanel.sass';

interface Props {
	tabs: any;
	setTabTitle: any;
	tabTitle: any;
}

function Tabpanel(props: Props) {	

	const [activeNavClass, setActiveNavClass] = useState(false);

	const tabs = props?.tabs._children.items;

	const setTabTitleProperty = (tab: any) => {
		setActiveNavClass(!activeNavClass);
		props.setTabTitle(`${tab.title} / ${setTabTime(tab)}`);
	};

	return (
		<div className="tab-panel">
			<div className="tab-panel__desktop">
				<div className="tab-panel__list">
					{tabs.map((tab: any) => (
						<NavLink
							to={tab._url}
							className="tab-panel__button"
							activeClassName="tab-panel__button--active"
							key={tab.title}
						>
							{tab.title} / {setTabTime(tab)}
						</NavLink>
					))}
				</div>
			</div>

			{/* Mobile nav */}
			<div className="tab-panel__mobile">
				<div className="tab-panel__dropdown tab-panel-dropdown">
					<span
						aria-hidden="true"
						onClick={() => setActiveNavClass(!activeNavClass)}
						className="tab-panel__button tab-panel__button--active"
					>
						{props.tabTitle}
						<svg width="8" height="5" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M3.75 5L0 .5V0h8v.5L4.25 5z"
								fill="#FFF"
								fillRule="nonzero"
							/>
						</svg>
					</span>
					<div
						className={`tab-panel-dropdown__list ${
							activeNavClass ? 'tab-panel-dropdown__list--active' : ''
						}`}
					>
						{tabs.map((tab: any) => (
							<NavLink
								to={tab._url}
								className="tab-panel__button"
								activeClassName="tab-panel__button--active"
								key={tab.title}
								onClick={() => setTabTitleProperty(tab)}
							>
								{tab.title} / {setTabTime(tab)}
							</NavLink>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}

export default Tabpanel;

function setTabTime(tab: any) {
	return `${new Date(tab.date).getDate()}.${
		(new Date(tab.date).getMonth() + 1).toString().length === 1
			? `0${new Date(tab.date).getMonth() + 1}`
			: `${new Date(tab.date).getMonth() + 1}`
	}.${new Date(tab.date).getFullYear()}`;
}